import React from 'react';
import Paragraph from 'src/elements/typography/paragraph';

const InactiveNetworkLayout = (): JSX.Element => (
  <Paragraph
    size='0.875rem'
    align='center'
    weight='light'
  >
    That Network is no longer available. But why not create your own? <b>Explore everything you can do on Mighty.</b> 👇
  </Paragraph>
);

export default InactiveNetworkLayout;
